import React from 'react';
import { useSelector } from 'react-redux';

import { isNewbuildingSelector } from '../../../selectors/newbuildingConsultant';
import { NewbuildingChatContainer } from '../NewbuildingChat';
import { ConsultantCianChat } from 'shared/containers/ConsultantCianChat';
import { isEnabledSelector } from 'shared/selectors/consultantCianChat';

/**
 *  Общий контейнер чатов
 * */
const ChatsContainer: React.FC = () => {
  const isNewbuildingsOnly = useSelector(isNewbuildingSelector);
  const isConsultantCianEnabled = useSelector(isEnabledSelector);

  if (isNewbuildingsOnly) {
    return isConsultantCianEnabled ? <ConsultantCianChat /> : <NewbuildingChatContainer />;
  }

  return null;
};

// eslint-disable-next-line import/no-default-export
export default ChatsContainer;
